import { jsx } from 'panel';
import { nameToInitials } from 'common/util/string';
import { TooltipEl } from 'common/components/tooltip';
import emptyIconImage from './empty-icon.svg';

const ImageIcon = (_ref) => {
  let {
    src,
    iconSize,
    handleAvatarImageLoaded,
    elref,
    isAvatarImageLoaded = true
  } = _ref;
  return jsx("div", {
    sel: '.image-icon.color-avatar',
    class: {
      loading: !isAvatarImageLoaded
    }
  }, jsx("img", {
    attrs: {
      elref,
      align: "middle",
      src,
      loading: "lazy"
    },
    style: {
      height: iconSize,
      width: iconSize
    },
    on: {
      load: handleAvatarImageLoaded
    }
  }));
};

const InitialsIcon = (_ref2) => {
  let {
    name,
    backgroundClassName
  } = _ref2;
  return jsx("div", {
    class: {
      [backgroundClassName]: true,
      'initials-icon': true
    },
    attrs: {
      elref: "initialsIcon"
    }
  }, nameToInitials(name));
};

const Placeholder = (_ref3) => {
  let {
    userIcon,
    iconSize,
    name
  } = _ref3;

  if (name) {
    return jsx(InitialsIcon, {
      name: name,
      backgroundClassName: userIcon.helpers.getBackgroundColorClass()
    });
  }

  return jsx(ImageIcon, {
    src: emptyIconImage,
    iconSize: iconSize,
    isAvatarImageLoaded: true,
    elref: 'defaultImg'
  });
};

const Avatar = (_ref4) => {
  let {
    userIcon,
    iconSize,
    name
  } = _ref4;
  const avatarUrl = userIcon.helpers.getAvatarUrl();
  const {
    isAvatarImageLoaded
  } = userIcon.state;

  if (avatarUrl) {
    return jsx(null, null, jsx(ImageIcon, {
      src: avatarUrl,
      iconSize: iconSize,
      isAvatarImageLoaded: isAvatarImageLoaded,
      elref: 'userImg',
      handleAvatarImageLoaded: userIcon.helpers.handleAvatarImageLoaded
    }), isAvatarImageLoaded ? null : jsx(Placeholder, {
      userIcon: userIcon,
      iconSize: iconSize,
      name: name
    }));
  }

  return jsx(Placeholder, {
    userIcon: userIcon,
    iconSize: iconSize,
    name: name
  });
};

export function template() {
  const {
    iconSize,
    fontSize
  } = this.helpers.getIconProperties();
  const name = this.helpers.getDisplayName();
  const labelPrefix = this.attr("label-prefix");
  const label = labelPrefix ? "".concat(labelPrefix, " ").concat(name) : name;
  const isTooltipDisabled = this.attr("disable-tooltip");
  const tooltipPlacement = this.attr("tooltip-placement");
  const tooltipText = this.attr("tooltip-text") || label;
  return jsx("div", {
    class: {
      container: true
    },
    on: {
      click: this.helpers.handleIconClick
    }
  }, jsx("div", {
    sel: '.avatar-container',
    style: {
      'font-size': "".concat(fontSize, "px"),
      height: "".concat(iconSize, "px"),
      'line-height': "".concat(iconSize, "px"),
      width: "".concat(iconSize, "px")
    }
  }, jsx(Avatar, {
    userIcon: this,
    iconSize: iconSize,
    name: name
  })), !isTooltipDisabled && tooltipText ? jsx(TooltipEl, {
    attrs: {
      placement: tooltipPlacement
    }
  }, tooltipText) : null, this.attr("include-label") ? jsx("div", {
    sel: '.label',
    attrs: {
      elref: "label"
    },
    style: {
      'line-height': "".concat(iconSize, "px")
    }
  }, label) : null);
}